import styled from 'styled-components'

export const StyledSpace = styled.div`
  padding: var(--spc-sm);
`
